export default "__VITE_ASSET__66524aa6__"